
import { Route } from '@/app/router'

const PartsDrafts = () => import('./index.vue')

const PartsDraftsMeta = {
	displayInSidebar: false,
	displayName: 'part-drafts'

}

const PartsDraftsProps = ['page', 'perPage']

export default new Route('/parts-drafts', PartsDrafts)
	.as('Dashboard:PartsDrafts')
	.meta(PartsDraftsMeta)
	.props(PartsDraftsProps)
	.permissions(['SHOW_PARTS', 'PROCESS_AI_IMAGES'])
